import React from "react"
import types from "prop-types"
import pluralize from "pluralize"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import GroupMenu from "./GroupMenu"

const GroupWithMembers = ({ group, removeGroup }) => {
  const { id, members, name } = group

  return (
    <ItemRow
      collapsable
      itemRowHeaderContent={(
        <a className="flex justify-between items-center w-full text-inherit" href={`/admin/groups/${id}`}>
          <span>{name}</span>
          <span className="text-sm text-dark">{pluralize("Member", members.length, true)}</span>
        </a>
      )}
      itemRowHeaderControls={(
        <GroupMenu group={group} removeGroup={removeGroup} />
      )}
      itemRowBody={(
        <>
          {
            group.members.map((member) => (
              <ItemRow
                key={member.id}
                className="dark"
                itemRowHeaderContent={(
                  <UserInfo user={member} />
                )}
              />
            ))
          }
        </>
      )}
    />
  )
}

GroupWithMembers.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  group: types.object.isRequired,
  removeGroup: types.func.isRequired,
}

export default GroupWithMembers
